import React, {PureComponent} from 'react';
import {Classes, Overlay} from "@blueprintjs/core";
import ReactToPrint from 'react-to-print';

import ReactToPdf from "react-to-pdf";
import RetinaImage from "react-retina-image";

export default class BillingInvoiceModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        viberEnableRequests: '',
        testNumber: '',
        modalData: this.props.modalData
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount = () => {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate = () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
        if (this.state.modalData !== this.props.modalData) {
            this.setState({
                modalData: this.props.modalData
            })
        }
    }


    // savePDF = () => {
    //     const input = document.querySelector('.billing-invoice-modal');
    //
    //     html2canvas(input)
    //         .then((canvas) => {
    //             const imgData = canvas.toDataURL('image/png');
    //             const pdf = new jsPDF();
    //             pdf.addImage(imgData, 'PNG', 0, 0);
    //             pdf.save("invoice.pdf");
    //         })
    //     ;
    //
    // }

    printPDF = async () => {
        // console.log('printingPDF')
        // let ids = ['printing-wrapper']
        // document.querySelector("#printing-wrapper").style.height = '297mm';
        // await print(ids)
        // document.querySelector("#printing-wrapper").style.height = '150mm';
        let printing = document.querySelector('#printing-wrapper')

    }

    render() {
        const ref = React.createRef()
        return (
            <React.Fragment>
                <style>
                    {`@media print 
                {
                .modal-field
                {width: 100% !important;} 
                .close-modal {display: none;} 
                .invoice-modal-buttons {display: none;}
                }`
                    }
                </style>
                <Overlay
                    onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                    isOpen={this.state.overlayIsOpen}
                    style={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >

                    <div className="modal-field billing-invoice-modal"
                         style={{
                             width: this.props.width || '50%',
                             maxWidth: this.props.maxWidth || '100%',
                             padding: 30
                         }}>
                        <div className="modal-header">

                            <span className='close-modal' onClick={() => {
                                this.props.handleClose()
                            }}>×</span>
                        </div>

                        <div ref={el => (this.componentRef = el)} className="billing-invoice">

                            <div style={{padding: 20}} ref={ref}>
                                <div className="row">
                                    <div className="col-sm-6 col-xs-12 text-left">
                                        {/*<RetinaImage className='invoice-emitto-logo' src={['/img/emitto-logo.png', '/img/emitto-logo.svg']}*/}
                                        {/*             checkIfRetinaImgExists={false}/>*/}
                                        <img src="/img/emitto-logo.png" className='invoice-emitto-logo'
                                             alt="Emitto invoice logo"/>
                                        <div className="text-left address m-lg-b">
                                            <p>Emitto Ltd</p>
                                            <p>Unit 6 Queens Yard, White Post Lane</p>
                                            <p>London</p>
                                            <p>E9 5EN</p>
                                            <p>United Kingdom</p>
                                            <p><span className="text-bold">phone:</span>(381) 606544564</p>
                                            <p><span className="text-bold">email:</span> office@emitto.io</p>

                                        </div>
                                    </div>
                                    <div className="col-sm-6  col-xs-12 text-right">
                                        <h1>
                                            Invoice
                                        </h1>
                                    </div>
                                </div>
                                <div className="separator m-lg-b"></div>
                                <div className="row invoice-info m-xl-b">


                                    <div className="col-sm-6 col-xs-12 invoice-name text-left">
                                        <p className="text-bold">Invoice to</p>
                                        <div className='invoice-to'>
                                            <p>{this.state.modalData.name}</p>
                                            {this.state.modalData.companyName !== '' ?
                                                <p>{this.state.modalData.companyName}</p>
                                                : ''
                                            }
                                            <p>{this.state.modalData.address !== '' ? this.state.modalData.address : ''}</p>
                                            <p>{this.state.modalData.email !== '' ? this.state.modalData.email : ''}</p>
                                            {this.state.modalData.vatNumber !== '' ?
                                                <p>VAT No. : {this.state.modalData.vatNumber}</p>
                                                : ''
                                            }
                                        </div>

                                    </div>
                                    <div className="col-sm-6 col-xs-12 payment-date-second  text-right">
                                        <p className="text-bold">Payment Date:</p>
                                        <p>{this.state.modalData.date}</p>
                                        <p className="text-bold">Invoice ID:</p>
                                        <p>{this.state.modalData.id}</p>
                                    </div>
                                </div>

                                <table>
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        {/*<th>Organization</th>*/}
                                        <th>Item</th>
                                        <th>Workspace</th>
                                        <th>Billing period</th>
                                        {/*<th>Renews At</th>*/}
                                        <th>Price</th>
                                        <th>Quantity</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr>
                                        <td>1</td>
                                        {/*<td>StartIt Group</td>*/}
                                        <td>
                                            {
                                                this.state.modalData.type === 'phone_subscription' ? 'Phone Subscription' :
                                                    <React.Fragment>
                                                        {this.state.modalData.description}<br/>
                                                        {this.state.modalData.yearly ? 'Additional Yearly Discount Applied' : ''}
                                                    </React.Fragment>}
                                        </td>
                                        <td>{this.state.modalData.project}</td>
                                        <td>{this.state.modalData.type === 'charge' ? 'N/A' : this.state.modalData.periodStart + ' - ' + this.state.modalData.periodEnd}</td>
                                        {/*<td>{this.state.modalData.periodEnd}</td>*/}
                                        {/*<td>{this.state.modalData.price}</td>*/}
                                        <td>{ this.state.modalData.currency }{this.state.modalData.subtotal ? this.state.modalData.subtotal : this.state.modalData.price}<br/>
                                        </td>
                                        <td>{this.state.modalData.quantity}</td>
                                    </tr>

                                    </tbody>
                                </table>
                                <div className="separator m-lg-b"></div>
                                <div className="row">
                                    <div className="col-xs-12 price-info text-right">
                                        <div>
                                            <p><span
                                                className="text-bold">Sub-total:</span> {this.state.modalData.currency}{this.state.modalData.subtotal ? this.state.modalData.subtotal : this.state.modalData.price}
                                            </p>

                                            {this.state.modalData.tax ?
                                                <p><span
                                                    className="text-bold">VAT:</span> {this.state.modalData.tax ? this.state.modalData.tax : 0}
                                                </p>
                                                :
                                                ''
                                            }
                                            {this.state.modalData.discount ?
                                                <p><span
                                                    className="text-bold">Discount: </span>{ this.state.modalData.currency }{this.state.modalData.discount}
                                                </p>
                                                :
                                                ''
                                            }
                                            {/*{this.state.modalData.amount_refunded ?*/}
                                            {/*    <p><span*/}
                                            {/*        className="text-bold">Refunded:</span> {this.state.modalData.amount_refunded}*/}
                                            {/*    </p>*/}
                                            {/*    :*/}
                                            {/*    ''*/}
                                            {/*}*/}
                                        </div>
                                        <div className="total-price text-bold">
                                            <h2>Total: {this.state.modalData.total !== '$NaN' && this.state.modalData.total || (this.state.modalData.total === 0) ?
                                                this.state.modalData.total : this.state.modalData.amount_refunded && this.state.modalData.amount ? this.state.modalData.currency +
                                                    (parseInt(this.state.modalData.amount.substring(1)) - parseInt(this.state.modalData.amount_refunded.substring(1))) :
                                                    this.state.modalData.price}
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12 text-left invoice-modal-buttons">

                                    <ReactToPrint
                                        trigger={() => {
                                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                            // to the root node of the returned component as it will be overwritten.
                                            return <button className="btn-lite">Print</button>;
                                        }}
                                        content={() => this.componentRef}
                                    />


                                    <ReactToPdf targetRef={ref} filename="invoice.pdf">
                                        {({toPdf}) => <button
                                            onClick={toPdf}
                                            className="btn-action">Download PDF
                                        </button>}
                                    </ReactToPdf>
                                </div>
                            </div>
                        </div>


                    </div>

                </Overlay>
            </React.Fragment>
        )
    }
}